import { z } from 'zod';

const SFkModel = z.object({
  user: z.null().optional(),
  referred_by: z.null().optional(),
  race: z.null().optional(),
});

const SDatum = z.object({
  id: z.null(),
  full_name: z.string().optional(),
  fk_model: SFkModel,
  whatsapp: z.string().optional(),
  email: z.string().optional(),
  username: z.string().optional(),
  password: z.string().optional(),
  nickname: z.string().optional(),
  gender: z.number().optional(),
  birthdate: z.string().optional(),
  tnc_version: z.string().optional(),
  privacy_version: z.string().optional(),
});

const SUpsert = z.object({
  model: z.string(),
  data: z.array(SDatum),
});

export const SRegisterRequest = z.object({
  delete: z.array(z.any()),
  upsert: z.array(SUpsert),
});
export type TRegisterRequest = z.infer<typeof SRegisterRequest>;

export const SVerifyOTPRequest = z.object({
  otp: z.string(),
});
export type TVerifyOTPRequest = z.infer<typeof SVerifyOTPRequest>;

export const TLoginRequest = z.object({
  username: z.string(),
  password: z.string(),
});
export type TLoginRequest = z.infer<typeof TLoginRequest>;
